export const selectModalVisibility = (state) =>
  state.salaryModuleReducer?.infoModal?.isVisible;

export const selectExcoInfoModalDataStatus = (state) =>
  state.salaryModuleReducer?.status;

export const selectExcoInfoModalData = (state) =>
  state.salaryModuleReducer?.infoModal?.info || {};

export const selectExcoInfoModalDataLastFinalizedDate = (state) =>
  state.salaryModuleReducer?.infoModal?.lastFinalization;

export const selectExcoInfoModalDataLastDeclarationPeriod = (state) =>
  state.salaryModuleReducer?.infoModal?.lastDeclarationPeriod;

export const selectIsPendingChanges = (state) =>
  state.salaryModuleReducer?.isPendingChanges;

export const selectModalEmployee = (state) =>
  state.salaryModuleReducer?.infoModal?.employee;

export const selectIsPendingChangesLoading = (state) =>
  state.salaryModuleReducer?.isLoading;
